// imports
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import { atom } from 'jotai'

// lib files
import { DefaultSearchFiltersObject, SearchFiltersObject } from '@/lib/content-services/search/search'

const searchFiltersAtom = atom<SearchFiltersObject>(DefaultSearchFiltersObject)

export { searchFiltersAtom }
